(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-avis"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tm-reviews')) {
    class TmReviews extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.track = this.querySelector('.tm-rv__track');
        this.prev = this.querySelector('[data-dir="-1"]');
        this.next = this.querySelector('[data-dir="1"]');
        this.addEventListener('click', (event) => {
          const arrow = event.target.closest('.tm-rv__arrow');
          if (!arrow) return;
          const card = this.track.querySelector('.tm-rv__card');
          const step = card.getBoundingClientRect().width + 16;
          const start = this.track.scrollLeft;
          const target = start + Number(arrow.dataset.dir) * step;
          this.track.scrollTo({ left: target, behavior: 'smooth' });
          setTimeout(() => {
            if (Math.abs(this.track.scrollLeft - start) < 2) this.track.scrollTo({ left: target, behavior: 'instant' });
            this.updateArrows();
          }, 700);
        });
        this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
        window.addEventListener('resize', () => this.updateArrows());
        this.updateArrows();
      }

      updateArrows() {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max;
      }
    }
    customElements.define('tm-reviews', TmReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-carrousel-coloris"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tm-color-carousel')) {
    class TmColorCarousel extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const island = this.querySelector('script[data-tm-cc-data]');
        this.data = JSON.parse(island.textContent);
        this.track = this.querySelector('.tm-cc__track');
        this.prev = this.querySelector('[data-dir="-1"]');
        this.next = this.querySelector('[data-dir="1"]');

        this.addEventListener('click', (event) => {
          const dot = event.target.closest('.tm-cc__dot');
          if (dot) {
            this.select(dot);
            return;
          }
          const arrow = event.target.closest('.tm-cc__arrow');
          if (arrow) {
            const card = this.track.querySelector('.tm-cc__card');
            const step = card.getBoundingClientRect().width + 16;
            const start = this.track.scrollLeft;
            const target = start + Number(arrow.dataset.dir) * step;
            this.track.scrollTo({ left: target, behavior: 'smooth' });
            setTimeout(() => {
              if (Math.abs(this.track.scrollLeft - start) < 2) this.track.scrollTo({ left: target, behavior: 'instant' });
              this.updateArrows();
            }, 700);
          }
        });
        this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
        window.addEventListener('resize', () => this.updateArrows());
        this.updateArrows();
      }

      updateArrows() {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max;
      }

      select(dot) {
        const card = dot.closest('.tm-cc__card');
        const color = this.data.colors.find((c) => c.name === dot.dataset.color);
        if (!color) return;
        const img = card.querySelector('.tm-cc__img');
        if (img && color.image) {
          img.removeAttribute('srcset');
          img.src = color.image;
        }
        card.querySelectorAll('.tm-cc__media, .tm-cc__name').forEach((a) => (a.href = color.url));
        card.querySelector('.tm-cc__name').textContent = color.name;
        card.querySelector('.tm-cc__price').textContent = `${this.data.fromText} ${color.price}`;
        card.querySelector('.tm-cc__sizes').textContent = `${color.sizes} ${color.sizes === 1 ? this.data.sizeSingular : this.data.sizePlural}`;
        card.querySelectorAll('.tm-cc__dot').forEach((d) => d.setAttribute('aria-pressed', String(d === dot)));
      }
    }
    customElements.define('tm-color-carousel', TmColorCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
